// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_1s-2";
export var blackBorderOnHover = "_1s-7";
export var cell = "_1s-6";
export var cellContainer = "_1s-3";
export var checked = "_1s-8";
export var disabled = "_1s-5";
export var featuredIconCellContainer = "_1s-9";
export var featuredIconTextContainer = "_1s-b";
export var featuredIconWrapper = "_1s-a";
export var noBorder = "_1s-c";
export var orangeSelectedRow = "_4j-3";
export var overflowableText = "_1s-0";
export var overflowableTextContainer = "_1s-1";
export var row = "_1t-0";
export var rowCheckboxCell = "_1s-4";
export var selectableTable = "_4j-2";